export default class HierarchyCategories {

    constructor(data) {

        this.categories = {};
        this.categoriesArr = [];

        this.getParentById = (parentCategoryId) => {
            return data.find(item => item.id === parentCategoryId);
        };
    
        this.getChildCategories = (id) => {
            return data.filter(item => item.parentCategoryId === id);
        };

        const isOrphanedCategory = c => c.hasChild && c.childCategories.length === 0;
        
        const updateParentOfOrphanedCategory = category => {
            
            category.isActive = "0";

            const parent = this.findCategoryById(category.parentCategoryId);

            if (!parent) {
                return;
            }

            parent.childCategories = parent.childCategories.filter(c => c.id !== category.id);

            if (isOrphanedCategory(parent)) {
                updateParentOfOrphanedCategory(parent);
            }
        };
        
        
        //1. parse initial categories
        data.forEach(data => this.categories[data.id] = this.parseCategory(data));
        this.categoriesArr = Object.values(this.categories);

        //2. find out which categories do not have any active children
        const orphanedCategories = this.categoriesArr.filter(c => isOrphanedCategory(c));

        //3. update orphaned category and related parents
        orphanedCategories.forEach(c => updateParentOfOrphanedCategory(c));
    }

    getParentsFor(category, result) {
        const parent = this.getParentById(category.parentCategoryId);

        if (!parent) {
            return result;
        }

        result.unshift(parent);
        return this.getParentsFor(parent, result);
    }

    parseCategory(data) {
            
        const childCategories = this.getChildCategories(data.id);

        const category = {
            ...data,
            level: data?.level ? parseInt(data.level) : -1,
            childCategories,
        };

        return category;
    }

    findCategoryById(id) {
        const cat = this.categoriesArr.find(item => item.id === parseInt(id));
        return cat;
    }

    findCategoryByName(name) {
        return this.categoriesArr.find(item => item.name.toLowerCase().trim() === name.toLowerCase().trim());
    }

    // TODO: We need to have the appointment type Id filtering - pass RDM-8193
    findCategoryByAppointmentTypeId(appointmentTypeId) {
        return this.categoriesArr.find(item => Number.parseInt(item.appointmentTypeId) === appointmentTypeId && !item.hasChild);
    }


    getCategoriesByLevel() {

        const groups = {};
        this.categoriesArr.forEach(data => {
            const {level} = data;
            if (!groups[level]) {
                groups[level] = [];
            }
            groups[level].push(data);
        });

        return Object.values(groups);
    }
}